import Service from "../Service";

const resource = "TasAdvaceProducerApproval/";

export default {

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    byID(parameters, requestID) {
        return Service.post(resource + "byid", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        console.log(obj)
        return Service.post(resource + "savemasive", obj, {
            params: { requestID: requestID },
        });
    },
    ApprovalTrackingList(parameters, requestID) {
        return Service.post(resource + "ApprovalTrackingList", parameters, {
            params: { requestID: requestID },
        });
    },
};